import React from "react";
import { Card } from './Card';

export interface CardsProps {
    game: any[],
    flippedCount: number,
    flippedIndexes: { index: number, side: string }[],
    setFlippedCount: React.Dispatch<React.SetStateAction<number>>,
    setFlippedIndexes: React.Dispatch<React.SetStateAction<{ index: number, side: string }[]>>,
    setScore: React.Dispatch<React.SetStateAction<number>>,
    score: number,
    matchedIndexes: number[],
    level: number,
    feedBack: JSX.Element,
    setFeedBack: React.Dispatch<React.SetStateAction<JSX.Element>>,
    turn: boolean,
    hideMatched: boolean
}

export function Cards(props: CardsProps): JSX.Element {

    const imageCards = props.game.slice(0, props.game.length / 2);
    const videoCards = props.game.slice(props.game.length / 2, props.game.length);
    const indexFix = props.game.length / 2;

    let cards = (
        <div className="grid grid-cols-2">
            <div className="flex flex-wrap justify-center">
                {imageCards.map((c, index) => (
                    <div className="m-0.5 p-0 xl:m-1" key={c.item.id + "_FirstOfPair" + index}>
                        <Card
                            index={index}
                            itemId={c.item.id}
                            file={c.file}
                            background={c.background}
                            flippedCount={props.flippedCount}
                            setFlippedCount={props.setFlippedCount}
                            flippedIndexes={props.flippedIndexes}
                            setFlippedIndexes={props.setFlippedIndexes}
                            setScore={props.setScore}
                            score={props.score}
                            matchedIndexes={props.matchedIndexes}
                            level={props.level}
                            feedBack={props.feedBack}
                            setFeedBack={props.setFeedBack}
                            turn={props.turn}
                            side={"left"}
                            hideMatched={props.hideMatched}
                        />
                    </div>
                ))}
            </div>
            <div className="flex flex-wrap justify-center">
                {videoCards.map((card, index) => (
                    <div className="m-0.5 p-0 xl:m-1" key={card.item.id + "_SecondOfPair" + index}>
                        <Card
                            index={index + indexFix}
                            itemId={card.item.id}
                            file={card.file}
                            background={card.background}
                            flippedCount={props.flippedCount}
                            setFlippedCount={props.setFlippedCount}
                            flippedIndexes={props.flippedIndexes}
                            setFlippedIndexes={props.setFlippedIndexes}
                            setScore={props.setScore}
                            score={props.score}
                            matchedIndexes={props.matchedIndexes}
                            level={props.level}
                            feedBack={props.feedBack}
                            setFeedBack={props.setFeedBack}
                            turn={props.turn}
                            side={"right"}
                            hideMatched={props.hideMatched}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
    return cards;
}